module.exports = __webpack_public_path__ + "img/customer_design_6.ea777b6.webp";